import { Component } from '@angular/core';
import { GlobalConstants } from 'src/app/common/global';
import { DeliveryComponent } from 'src/app/components/delivery/delivery.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-buy-membership-order',
  templateUrl: './buy-membership-order.component.html',
  styleUrls: ['./buy-membership-order.component.sass'],
  standalone: true,
  imports: [DeliveryComponent]
})
export class BuyMembershipOrderComponent {
  customerProfile: any;

  constructor() {}
}
